import {createContext, PropsWithChildren, useEffect, useRef} from 'react';
import {useFrame} from './frame';
import ChekinProSettings from '../ChekinProSettings';
import {getIsSDKLimitedMode} from '../utils/sdk';

const HeightObserverContext = createContext(undefined);

export const HeightObserverProvider = ({children}: Readonly<PropsWithChildren>) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const {frame} = useFrame();
  const prevHeightRef = useRef<number>();
  const canObserve =
    getIsSDKLimitedMode() && ChekinProSettings.settings.autoHeight && frame;

  useEffect(() => {
    const element = ref.current;
    if (!element || !canObserve) return;

    const observer = new ResizeObserver(entries => {
      const height = entries[0].contentRect.height;
      if (height !== prevHeightRef.current && frame) {
        frame.style.height = `${height}px`;
        prevHeightRef.current = height;
        ChekinProSettings.events.onHeightChanged(height);
      }
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, [canObserve, frame]);

  return (
    <HeightObserverContext.Provider value={undefined}>
      {canObserve ? (
        <div ref={ref} className={'HeightObserverProvider'} style={{overflowY: 'hidden'}}>
          {children}
        </div>
      ) : (
        children
      )}
    </HeightObserverContext.Provider>
  );
};
